export const getColumns = (groupBy = "") => {
  const baseColumns = [
    {
      field: "total_delay_picking",
      headerName: "Total Delay Picking",
      flex: 1,
      minWidth: 120,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "total_completed_picking",
      headerName: "Total Completed Picking",
      flex: 1,
      minWidth: 120,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "total_on_hold",
      headerName: "Total On Hold",
      flex: 1,
      minWidth: 120,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "total_cancelled",
      headerName: "Total Cancelled",
      flex: 1,
      minWidth: 120,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "total_dollar_amount",
      headerName: "Total Dollar Amount",
      flex: 1,
      minWidth: 120,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
  ];

  // Always include bay_code as the first column
  const columns = [
    {
      field: "bay_code",
      headerName: "Bay Code",
      flex: 0.8,
      minWidth: 80,
    },
  ];

  // Add conditional columns based on groupBy
  if (groupBy === "customer") {
    columns.push({
      field: "customer",
      headerName: "Customer",
      flex: 0.8,
      minWidth: 80,
    });
  }

  if (groupBy === "category") {
    columns.push({
      field: "category",
      headerName: "Category",
      flex: 0.8,
      minWidth: 80,
    });
  }

  return [...columns, ...baseColumns];
};
